import { Reducer } from "redux";

import { EligibilityInformationResponse } from "../models/api/Patient";
import { EligibilityInformationDispatchTypes } from "../models/dispatchTypes/Patient";
import { EligibilityInformationActionDispatchTypes } from "../constants/eligibility";

const initialState: EligibilityInformationResponse = {
    loading: false,
    response: {
        lastName: "",
        dob: "",
        policyId: "",
        payerId: "",
        payerName: "",
        firstName: "",
        eligibilityId: 0,
        eligibilityStatus: ""
    },
};

const EligibilityInformation: Reducer<EligibilityInformationResponse, EligibilityInformationDispatchTypes> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case EligibilityInformationActionDispatchTypes.SET_ELIGIBILITY_INFORMATION_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case EligibilityInformationActionDispatchTypes.SET_ELIGIBILITY_INFORMATION_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
    }
    return state;
};

export default EligibilityInformation;